import i18n from "i18next";

export const applyValidation = (x) => {
  x.currentTarget.setCustomValidity(i18n.t("Fill out this field"));
};
export const resetValidation = (x) => {
  x.currentTarget.setCustomValidity("");
};
